<template>
  <div class="blog-cta">
    <img class="app-icon" alt="Wotive app icon" src="../../assets/wotive-icon.svg">
    <h2>Wotive</h2>
    <p>Free Social Gym Tracker</p>
    <div class="download-icons">
      <AppleButton />
      <GoogleButton />
    </div>
  </div>
</template>

<script>
import GoogleButton from '../buttons/GoogleButton.vue';
import AppleButton from '../buttons/AppleButton.vue';

export default {
  name: 'AboutWotive',

  components: {
    GoogleButton,
    AppleButton,
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.blog-cta {
  .app-icon {
    width: 64px;
    height: 64px;
  }

  h2 {
    font-size: 16px;
    font-weight: bold;
    color: $sec1;
    padding: 0;
    margin: 0;
  }

  p {
    margin: 0;
    padding: 0;
    margin-bottom: 8px;
  }

  .download-icons {
    img {
      height: 40px;
      margin-right: 8px;
    }
  }
}
</style>